import { z } from 'zod';
import { GetCustomerInfoResponseSchema } from '../customer-info/get-customer-info.ts';
import { NestedProductGroupResponseSchema } from '../product-group/NestedGroupResponseEntity.ts';
import { ORDER_STATUS_SCHEMA } from './order-status.ts';
import { ORDER_SOURCE_SCHEMA } from './order-source.ts';

export const GetOrderUrlSchema = z.object({
    orderId: z.string().uuid(),
});

/**
 * validation schema for query params
 */
export const GetOrderQuerySchema = z.object({
    // extend order with product-groups
    includeGroups: z.coerce.boolean(),
    // extend order (product-groups) with order products
    includeProducts: z.coerce.boolean(),
    // extend order (groups -> products) with bundles
    includeBundles: z.coerce.boolean(),
    // extend order (groups -> products) with quotes
    includeQuotes: z.coerce.boolean(),
});

/**
 * validation schema for response payload
 */

const BaseOrderSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.coerce.date(),
    customerInfo: GetCustomerInfoResponseSchema.nullable(),
    productGroups: z.array(NestedProductGroupResponseSchema).optional(),
    marketCode: z.string(),
    positionId: z.string().nullable(),
    source: ORDER_SOURCE_SCHEMA.nullish(),
});

export const GetOrderResponseSchema = z.discriminatedUnion('status', [
    BaseOrderSchema.extend({
        status: z.literal(ORDER_STATUS_SCHEMA.enum.DRAFT),
        humanReadableId: z.literal(null), // Must be null for DRAFT
    }),
    BaseOrderSchema.extend({
        status: z.literal(ORDER_STATUS_SCHEMA.enum.SUBMITTED),
        humanReadableId: z.string().length(11), // Required for SUBMITTED
    }),
]);

export type GetOrderResponse = z.infer<typeof GetOrderResponseSchema>;
